import { TextField, Typography } from '@mui/material';
import React from 'react';

export function EmailChips({ emailItemsGet }) {
  const [value, setValue] = React.useState('');
  const [items, setItems] = React.useState([]);
  const [error, setError] = React.useState(null);

  const handleKeyDown = evt => {
    if (['Enter', 'Tab', ','].includes(evt.key)) {
      evt.preventDefault();

      const trimmedValue = value.trim();

      if (trimmedValue && isValid(trimmedValue)) {
        emailItemsGet([...items, trimmedValue.toLowerCase()]);
        setItems([...items, trimmedValue.toLowerCase()]);
        setValue('');
      }
    }
  };

  const handleChange = evt => {
    setValue(evt.target.value);
    setError(null);
  };

  const handleDelete = item => {
    emailItemsGet(items.filter(i => i !== item));

    setItems(items.filter(i => i !== item));
  };

  const handlePaste = evt => {
    evt.preventDefault();

    const paste = evt.clipboardData.getData('text');
    const emails = paste.match(/[\w\d.-]+@[\w\d.-]+\.[\w\d.-]+/g);

    if (emails) {
      const toBeAdded = emails.filter(email => !items.includes(email));
      emailItemsGet([...items, ...toBeAdded]);
      setItems([...items, ...toBeAdded]);
      setValue('');
    }
  };

  const isValid = email => {
    let errorMessage = null;

    if (items.includes(email)) {
      errorMessage = `${email} já foi adicionado.`;
    }

    if (!/[\w\d.-]+@[\w\d.-]+\.[\w\d.-]+/.test(email)) {
      errorMessage = `${email} não é um e-mail válido.`;
    }

    if (errorMessage) {
      setError(errorMessage);

      return false;
    }

    return true;
  };

  return (
    <>
      {items.map(item => (
        <div
          style={{
            backgroundColor: '#d4d5d6',
            fontSize: '14px',
            borderRadius: '30px',
            height: '30px',
            padding: '0 4px 0 1rem',
            display: 'inline-flex',
            alignItems: 'center',
            margin: '0 0.3rem 0.3rem 0',
          }}
          className='tag-item'
          key={item}
        >
          {item}
          <button
            style={{
              backgroundColor: 'white',
              width: '22px',
              height: '22px',
              borderRadius: '50%',
              border: 'none',
              cursor: 'pointer',
              font: 'inherit',
              marginLeft: '10px',
              fontWeight: 'bold',
              padding: '0',
              lineHeight: '1',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: 'Montserrat',
            }}
            type='button'
            className='button'
            onClick={() => handleDelete(item)}
          >
            &times;
          </button>
        </div>
      ))}

      <TextField
        fullWidth
        variant='outlined'
        style={{ marginTop: '1rem' }}
        className={`input ${error && ' has-error'}`}
        value={value}
        error={error}
        label='E-mails'
        placeholder='Digite ou cole e-mails e, para adicioná-los, aperte `Enter`...'
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        onPaste={handlePaste}
      />

      {error && (
        <Typography variant='inherit' color='textSecondary'>
          {error}
        </Typography>
      )}
    </>
  );
}
